declare namespace $ {

	export class $bog_pazzle_layout extends $mol_view {
		Menu( ): $bog_pazzle_menu
		Upload( ): $bog_pazzle_upload
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=layout.view.tree.d.ts.map